export enum localStorageKeys {
  sidebarOpened = "sidebarOpened",
  authHeader = "authHeader",
  cookieConsentKey = "cookiebanner_consented",
  userBackCookie = "cookie-0",
}
